import { FC } from 'react';
import styles from './index.module.less';
import { IProduct } from '@pro/product/interface';
import { Image } from '@base/lib/ThemeImage';
import { LoopRender } from '@base/snippets/LoopRender';
import cn from 'classnames';
import { GridRender } from '@base/snippets/GridRender';
import { isPhone } from 'base/utils/client';

type IProps = {
    product: IProduct;
};

const Tag: FC<{
    icon: string;
    title: string;
    description: string;
    className?: string;
}> = ({ icon, title, description, className }) => (
    <div className={cn(styles.tag, className)}>
        <Image width={isPhone ? 68 : 140} src={icon} background={false} fixed pure/>
        <div className={styles['tag-text']}>
            <p className={styles['tag-title']}>{title}</p>
            <p className={styles['tag-desc']}>{description}</p>
        </div>
    </div>
)

export const ProdFeatureTagsV2: FC<IProps> = ({ product }) => {
    const { features } = product;

    return !features?.length ? null : (
        <div className={styles['feature-tags']}>
            {isPhone ? (
                <LoopRender
                    className={styles.tags}
                    list={features.reduce((acc, curr) => [...acc, ...curr], [])}
                    render={(fea, { index }) => <Tag {...fea} className={index % 2 === 0 ? styles['tag-ltr'] : styles['tag-rtl']}/>}
                />
            ) : (
                <div className={cn(styles.tags, 'wrapper text-center')}>
                    <LoopRender
                        tag={false}
                        list={features}
                        render={(group, { first }) => first ? (
                            <div className={styles['group-large']}>
                                <GridRender
                                    colsPerRow={2}
                                    gutter={186}
                                    list={group}
                                    render={fea => (
                                        <Tag {...fea}/>
                                    )}/>
                            </div>
                        ) : (
                            <div>
                                <GridRender
                                    colsPerRow={3}
                                    gutter={66}
                                    list={group}
                                    render={fea => (
                                        <Tag {...fea}/>
                                    )}/>
                            </div>
                        )}
                    />
                </div>
            )}
        </div>
    )
};
